const colors = {
  // --- Paleta Semântica Principal ---
  // Azul-marinho institucional = marca/ação. Verde = único acento (preço/sucesso).
  // Neutros (background/border/text) formam toda a base. Use SEMPRE estes nomes.
  primary: '#1e3a8a',
  secondary: 'rgb(19, 85, 154)',
  success: '#10b981',
  error: '#ef4444',
  danger: '#ef4444', // alias de error (usado em botões destrutivos)
  warning: '#f59e0b',
  info: '#3b82f6',

  // --- Cores de Texto ---
  textPrimary: '#334155',
  textSecondary: '#64748b',
  textLight: '#94a3b8',

  // --- Cores de Fundo ---
  background: '#f8fafc',
  backgroundAlt: '#ffffff',

  // --- Cores de UI (Bordas, Hovers, etc) ---
  border: '#e2e8f0',
  borderLight: '#f1f5f9',
  hoverPrimary: '#1e40af',
  hoverSecondary: '#0f4c75',
  lightBlue: '#dbeafe',
  white: '#ffffff',

  // --- Gradiente (único; evite gradientes ad-hoc nos componentes) ---
  gradientPrimary: 'linear-gradient(135deg, #1e3a8a 0%, rgb(19, 85, 154) 100%)',

  // --- Aliases de compatibilidade (deprecados: prefira os nomes semânticos acima) ---
  primaryBlue: '#1e3a8a',
  secondaryBlue: 'rgb(19, 85, 154)',
  grayLight: '#f8fafc',
  grayMedium: '#64748b',
  grayDark: '#334155',
  successGreen: '#10b981',
  errorRed: '#ef4444',
  warningYellow: '#f59e0b',
};

const theme = {
  colors,
  fonts: {
    primary: "'Montserrat', sans-serif",
    weights: { light: 300, regular: 400, medium: 500, semibold: 600, bold: 700 },
    // Escala tipográfica (rem). Use no lugar de px soltos.
    sizes: { xs: '0.75rem', sm: '0.875rem', base: '1rem', lg: '1.125rem', xl: '1.25rem', '2xl': '1.5rem', '3xl': '1.875rem', '4xl': '2.25rem' }, // prettier-ignore
  },
  sizes: {
    mobile: '480px', tablet: '768px', desktop: '1024px', largeDesktop: '1200px',
    space: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px', xxl: '48px', xxxl: '64px' }, // prettier-ignore
    radius: { sm: '4px', md: '8px', lg: '12px', xl: '16px', xxl: '24px', round: '50%', pill: '9999px' }, // prettier-ignore
    container: { sm: '640px', md: '768px', lg: '1024px', xl: '1280px', xxl: '1536px' },
  },
  // Helpers de media query — use como ${p => p.theme.media.tablet} { ... }
  media: {
    mobile: '@media (max-width: 480px)',
    tablet: '@media (max-width: 768px)',
    desktop: '@media (max-width: 1024px)',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    card: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)',
  },
  transitions: {
    fast: '0.15s ease',
    normal: '0.3s ease', // Usar para botões, inputs, cards, etc.
    slow: '0.5s ease',
  },
  zIndex: { base: 1, dropdown: 10, sticky: 20, modal: 30, popover: 40, tooltip: 50, notification: 60, max: 9999 },
  status: {
    // Referenciando as cores principais para consistência
    active: { background: colors.success, color: colors.white, border: colors.success },
    pending: { background: colors.warning, color: colors.white, border: colors.warning },
    inactive: { background: colors.error, color: colors.white, border: colors.error },
    paid: { background: colors.success, color: colors.white, border: colors.success },
    overdue: { background: colors.error, color: colors.white, border: colors.error },
  },
  layout: { headerHeight: '70px', footerHeight: '60px', sidebarWidth: '280px', containerPadding: '20px', mobilePadding: '15px' },
};

export default theme;
